import {Component, OnInit} from '@angular/core';
import {StorageService, AuthenticationService} from '../../services';
import {JwtHelperService} from '@auth0/angular-jwt';

@Component({
  selector: 'app-default-master',
  templateUrl: './default-master.html',
  styleUrls: ['./default-master.scss']
})
export class DefaultMasterPageComponent implements OnInit {
  loaded: boolean;
  user: any;
  isMenuCollapsed: boolean;

  constructor(private storage: StorageService,
              private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.loaded = true;
    const token = this.storage.accessToken;
    if (token) {
      const data = new JwtHelperService().decodeToken(token);
      if (data.exp && ((data.exp * 1000) - new Date().getTime()) > 0) {
        this.loaded = true;
      } else {
        this.authenticationService.logout();
      }
    } else {
      this.authenticationService.logout();
    }

    //  this.collapseMenuForSmallScreen();
    if (window.innerWidth < 1280){
      this.isMenuCollapsed = true;
    }

    window.addEventListener(
        'resize',
        () => {if (window.innerWidth < 1280){
          this.isMenuCollapsed = true;
        }},
        false
    );

  }

  // collapseMenuForSmallScreen() {
  //   if (window.innerWidth < 1280){
  //     this.isMenuCollapsed = true;
  //   }
  // }

  onMenuToggle() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
  }
}
